import { useNavigate } from 'react-router-dom';
import Modal from '../Modal/Modal';
import Button from '../Button/Button';
import { useAuth } from '../../context/AuthContext/AuthContext';

const PayoutGateModal = () => {
    const navigate = useNavigate();
    // Sign out directly instead of opening the shared logout confirmation modal:
    // that modal renders at the same stacking level and would sit behind this gate,
    // making it unreachable. Logging out is the gate's only escape, so skip the confirm.
    const { clearSession, isLoggingOut } = useAuth();

    const goToPayoutSetup = () => {
        navigate('/dashboard/payout-details');
    };

    return (
        <Modal
            show={true}
            allowCloseVeilClick={false}
            showTopCloseButton={false}
            size="medium"
        >
            <h2 className="text-2xl leading-8 font-bold text-gray-900">
                Set up your payouts
            </h2>
            <div className="my-8 text-base text-gray-500">
                <p>
                    Before adding your property profile, let's get your payout details in
                    place. This way you're ready to earn the moment your property goes live.
                </p>
            </div>
            <div className="flex flex-col items-center gap-y-4">
                <Button onClick={goToPayoutSetup} variant="primary" size="normal" className="w-full">
                    Set up payouts
                </Button>
                <Button onClick={clearSession} loading={isLoggingOut} variant="text-link" size="small">
                    Log out
                </Button>
            </div>
        </Modal>
    );
};

export default PayoutGateModal;
